import { msalAuthClient } from "./msal.client";
import { fakeAuthClient } from "./fake.client";
import type { AuthClient } from "./auth.types";

const useFake = (process.env.REACT_APP_USE_FAKE_MSAL ?? "false") === "true";

export const authClient: AuthClient = useFake ? fakeAuthClient : msalAuthClient;
